import { render, staticRenderFns } from "./RecorderStatus.vue?vue&type=template&id=d6017700&scoped=true&"
import script from "./RecorderStatus.vue?vue&type=script&lang=js&"
export * from "./RecorderStatus.vue?vue&type=script&lang=js&"
import style0 from "./RecorderStatus.vue?vue&type=style&index=0&id=d6017700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6017700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/q7gCdwre/0/h5group/renpho-lex/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6017700')) {
      api.createRecord('d6017700', component.options)
    } else {
      api.reload('d6017700', component.options)
    }
    module.hot.accept("./RecorderStatus.vue?vue&type=template&id=d6017700&scoped=true&", function () {
      api.rerender('d6017700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RecorderStatus.vue"
export default component.exports